const SET_HOLIDAYS = 'directOrderRecurring/SET_HOLIDAYS';

export default {
  SET_HOLIDAYS,
};
